import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppModuleListPage } from './app-module-list';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    AppModuleListPage,
  ],
  imports: [
    IonicPageModule.forChild(AppModuleListPage),
    PipesModule,
    DirectivesModule,
    ComponentsModule,

  ],
})
export class AppModuleListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-module-list/app-module-list.module.ts